"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canView = canView;
exports.canEdit = canEdit;
exports.isFieldHidden = isFieldHidden;
/** Whether a viewer may read an object at all. Default deny. */
function canView(payload, object) {
    return payload.permissions[object]?.level !== 'none';
}
/**
 * Whether a viewer may change an object. A read-only cell is not a write, and an
 * impersonated session may never write anything at all (F1.10).
 */
function canEdit(payload, object) {
    if (payload.isImpersonating)
        return false;
    const cell = payload.permissions[object];
    if (!cell)
        return false;
    return cell.level !== 'none' && cell.level !== 'read' && !cell.isReadOnly;
}
/** True when this viewer's §L23 rules hide the given field path. */
function isFieldHidden(payload, field) {
    return payload.hiddenFields.includes(field);
}
//# sourceMappingURL=session-payload.js.map